import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AppSetting } from '../models/AppSetting';

@Injectable({
  providedIn: 'root'
})
export class AppSettingService {


  constructor(private httpClient: HttpClient) { }

  find(organizationId:number): Observable<AppSetting[]> {
    return this.httpClient.get<AppSetting[]>(environment.apiUrl + "app-settings/"+organizationId);
  }

  save(organizationId:number, appSettings: AppSetting[]): Observable<void> {
      return this.httpClient.put<void>(environment.apiUrl + "app-settings/" + organizationId, appSettings);
  }
 
}  